import { Button, ModalBody, ModalFooter, ModalHeader } from "@chakra-ui/react"
import Documents from "../../../../src/components/features/pdp/Sections/Documents/Documents"
import { DocumentModel } from "../../../api-clients/product-api-v1"
import { useBrandedTranslation } from "../../../common/hooks/useBrandedTranslation"
import { CustomModalPropTypes } from "../../../common/types/useModal"

type Props = {
  Modal: (arg0: CustomModalPropTypes) => JSX.Element
  onClose?: () => void
  articleNumber: string
  documents: DocumentModel[]
}

const DocumentsModal = ({ Modal, onClose, articleNumber, documents }: Props) => {
  const { t } = useBrandedTranslation()

  return (
    <Modal
      modalContentStyleProps={{ mx: "0" }}
      size={{ base: "full", sm: "3xl", md: "4xl", lg: "6xl" }}
      scrollBehavior="inside"
      customOnClose={onClose}
    >
      <ModalHeader
        mt={{ base: "2", sm: "4" }}
        px={{ base: "4", sm: "8" }}
        fontWeight="medium"
        fontSize={{ base: "lg", sm: "xl" }}
      >
        {`${t("spdp-documentTitle")} ${articleNumber}`}
      </ModalHeader>

      <ModalBody py="0" px={{ base: "4", sm: "8" }}>
        <Documents documents={documents} isExtendedByDefault={true} hasSectionTitle={false} />
      </ModalBody>

      <ModalFooter
        px={{ base: "4", sm: "8" }}
        pt={{ base: "6", sm: "8" }}
        pb={{ base: "10", sm: "8" }}
        justifyContent={{ base: "center", sm: "flex-end" }}
      >
        <Button variant="primary" onClick={onClose} w={{ base: "100%", sm: "auto" }}>
          {t("lst-seconderyPopup-button")}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default DocumentsModal
